import { connect } from 'react-redux';
import LoginView from './LoginView';

const mapStateToProps = (state) => {
  const { error, redirect } = state.global;
  const { payload = {}, query = {}, meta = {} } = state.location;
  return {
    show: error || redirect ? false : true,
    error,
    redirect,
    payload,
    query,
    meta,
  };
};

const mapDispatchToProps = dispatch => ({
  routeToPage: (props) => {
    dispatch({ type: 'PAGE', payload: { ...props }, query: {} });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);



// WEBPACK FOOTER //
// ./src/views/Login/LoginContainer.js